import type { EmotePage } from "odyssey-shared";
import type { GlyphName } from "../../ui/kit/Glyph.tsx";

/**
 * The glyph on each page's marker in the wheel's crown (P2.19-T11; the design's `emotes` card: user, heart,
 * human-run, users and tournament at 10, and a face for the Emoji page), drawn at 10 under `src/ui/art/marks/glyph/`.
 */
export const PAGE_MARKS: Readonly<Record<EmotePage, GlyphName>> = {
  Emoji: "face",
  Greetings: "user-medium",
  Emotions: "heart",
  Actions: "human-run-medium",
  Interactions: "users",
  Duel: "tournament",
};
